import(/* webpackMode: "eager" */ "/codebuild/output/src1235941874/src/CVCircuit/frontend/app/global-error.tsx");
